import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, X, Zap } from 'lucide-react';
import useAICreditStore from '../../stores/useAICreditStore';
import './CreditWarningToast.css';

export default function CreditWarningToast() {
    const navigate = useNavigate();
    const { credits, isLoading } = useAICreditStore();
    const warningLevel = useAICreditStore(state => state.getWarningLevel());
    const aiMode = useAICreditStore(state => state.getAIMode());
    
    const [isVisible, setIsVisible] = useState(false);
    const [lastShownLevel, setLastShownLevel] = useState(null);

    useEffect(() => {
        if (isLoading) return;

        // Skip if they are using their own key
        if (aiMode === 'byok') return;

        // Only show once per warning level threshold
        if (warningLevel !== 'ok' && warningLevel !== lastShownLevel) {
            setIsVisible(true);
            setLastShownLevel(warningLevel);

            // Auto-hide after 8 seconds unless depleted
            if (warningLevel !== 'depleted') {
                const timer = setTimeout(() => setIsVisible(false), 8000);
                return () => clearTimeout(timer);
            }
        }
    }, [warningLevel, lastShownLevel, isLoading, aiMode]);

    if (!isVisible) return null;

    return (
        <div className={`credit-warning-toast credit-warning-toast--${warningLevel}`}>
            <div className="credit-warning-toast__icon">
                {warningLevel === 'depleted' ? <AlertCircle size={20} /> : <Zap size={20} />}
            </div>
            <div className="credit-warning-toast__content">
                {warningLevel === 'depleted' ? (
                    <>
                        <h4>Credits Depleted</h4>
                        <p>You have 0 AI credits left this month. Upgrade to continue using AI.</p>
                    </>
                ) : warningLevel === 'critical' ? (
                    <>
                        <h4>Running Low</h4>
                        <p>Only {credits} AI credits remaining this month.</p>
                    </>
                ) : (
                    <>
                        <h4>Credit Warning</h4>
                        <p>You have {credits} AI credits left this month.</p>
                    </>
                )}
            </div>
            <div className="credit-warning-toast__actions">
                <button 
                    className="btn btn-primary btn-sm"
                    onClick={() => {
                        setIsVisible(false);
                        navigate('/settings?tab=membership');
                    }}
                >
                    Buy More
                </button>
                <button 
                    className="btn btn-ghost btn-sm btn-icon credit-warning-toast__close"
                    onClick={() => setIsVisible(false)}
                >
                    <X size={16} />
                </button>
            </div>
        </div>
    );
}
